import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const token = sessionStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
      return;
    }

    // Load bookings
    fetch(`${API_URL}/api/admin/bookings`, {
      headers: { 'Authorization': `Bearer ${token}` }
    })
    .then(res => res.ok ? res.json() : [])
    .then(data => setBookings(data || []))
    .catch(() => setBookings([]));
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/admin/login');
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f3f4f6', fontFamily: 'system-ui, -apple-system, sans-serif' }}>
      <div style={{ 
        backgroundColor: '#10b981', 
        color: 'white',
        padding: '1.5rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
      }}>
        <h1 style={{ fontSize: '1.75rem', fontWeight: 'bold', margin: 0 }}>
          ReturnPal Admin
        </h1>
        <button 
          onClick={handleLogout}
          style={{
            padding: '0.625rem 1.25rem',
            backgroundColor: 'white',
            color: '#10b981',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '0.875rem'
          }}
        >
          Logout
        </button>
      </div>

      <div style={{ padding: '2rem', maxWidth: '1200px', margin: '0 auto' }}>
        <div style={{ 
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '2rem',
          boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
        }}>
          <h2 style={{ 
            fontSize: '1.5rem', 
            fontWeight: 'bold', 
            marginBottom: '1.5rem',
            color: '#111827'
          }}>
            All Bookings ({bookings.length})
          </h2>

          {bookings.length === 0 ? (
            <div style={{ 
              padding: '4rem 2rem', 
              textAlign: 'center',
              backgroundColor: '#f9fafb',
              borderRadius: '8px',
              border: '2px dashed #e5e7eb'
            }}>
              <p style={{ 
                color: '#6b7280', 
                fontSize: '1.125rem',
                margin: 0 
              }}>
                No bookings yet. Waiting for first customer! 🎉
              </p>
            </div>
          ) : (
            <div style={{ display: 'grid', gap: '1rem' }}>
              {bookings.map((booking) => (
                <div 
                  key={booking.id || booking.confirmation_number}
                  style={{
                    backgroundColor: '#f9fafb',
                    padding: '1.5rem',
                    borderRadius: '8px',
                    border: '1px solid #e5e7eb',
                    transition: 'all 0.2s',
                    cursor: 'default'
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 4px 6px rgba(0,0,0,0.1)';
                    e.currentTarget.style.borderColor = '#10b981';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = 'none';
                    e.currentTarget.style.borderColor = '#e5e7eb';
                  }}
                >
                  <div style={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    marginBottom: '1rem',
                    flexWrap: 'wrap',
                    gap: '1rem'
                  }}>
                    <div>
                      <p style={{ 
                        fontWeight: 'bold', 
                        fontSize: '1.25rem',
                        color: '#111827',
                        margin: '0 0 0.5rem 0'
                      }}>
                        #{booking.confirmation_number || 'N/A'}
                      </p>
                      <p style={{ 
                        color: '#6b7280', 
                        fontSize: '0.875rem',
                        margin: 0 
                      }}>
                        {booking.user_email || booking.customer_email || 'No email'}
                      </p>
                      <p style={{ 
                        color: '#6b7280', 
                        fontSize: '0.875rem',
                        margin: '0.25rem 0 0 0'
                      }}>
                        {booking.user_name || booking.customer_name || 'No name'}
                      </p>
                    </div>
                    <div style={{ textAlign: 'right' }}>
                      <p style={{ 
                        fontWeight: 'bold', 
                        color: '#10b981', 
                        fontSize: '1.5rem',
                        margin: '0 0 0.5rem 0'
                      }}>
                        ${(booking.total_cost || 0).toFixed(2)}
                      </p>
                      <p style={{ 
                        color: '#6b7280', 
                        fontSize: '0.875rem',
                        margin: 0
                      }}>
                        {booking.pickup_date || 'No date'}
                      </p>
                    </div>
                  </div>
                  
                  <div style={{ 
                    paddingTop: '1rem',
                    borderTop: '1px solid #e5e7eb',
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                    gap: '0.75rem',
                    fontSize: '0.875rem',
                    color: '#374151'
                  }}>
                    <p style={{ margin: 0 }}>
                      <strong>Packages:</strong> {booking.number_of_packages || 0}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Location:</strong> {booking.location_name || 'N/A'}
                    </p>
                    <p style={{ margin: 0 }}>
                      <strong>Status:</strong> <span style={{
                        padding: '0.25rem 0.5rem',
                        backgroundColor: booking.status === 'completed' ? '#d1fae5' : '#fef3c7',
                        color: booking.status === 'completed' ? '#065f46' : '#92400e',
                        borderRadius: '4px',
                        fontWeight: '600'
                      }}>
                        {booking.status || 'pending'}
                      </span>
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
